import Swiper from 'swiper';
import 'swiper/css';

export default () => ({
  swiper: null,

  init() {
    if (window.innerWidth >= 1024) {
      return;
    }

    this.swiper = new Swiper(this.$refs.swiper, {
      slidesPerView: 1.3,
      spaceBetween: 20,
      loop: false,
    });
  },
});